import {useEffect} from 'react';
import { makeStyles } from '@material-ui/styles';
import theme from '../theme';
// @ts-ignore
import CloseIcon from '../../public/images/icons/close.svg';
import { Drawer } from '@material-ui/core';

const useStyles = makeStyles({
    drawer: {
        '@media (any-pointer: coarse)': {
            top: 'var(--inner-header-bottom) !important',
            height: 'calc(100vh - var(--inner-header-bottom))',
            '& .MuiBackdrop-root': {
                zIndex: 2,
                top: 'var(--inner-header-bottom) !important',
            }
        },
    },
    paper: {
        bottom: 0,
        width: 600,
        maxWidth: '90vw',
        overflow: 'auto',
        '@media (any-pointer: coarse)': {
            top: 'var(--inner-header-bottom) !important',
            height: 'calc(100vh - var(--inner-header-bottom))',
        },
    },
    wrapper: {
        display: 'flex',
        padding: '55px 33px 0px',
        flexDirection: 'column',
        width: 600,
        maxWidth: '90vw',
        overflowX: 'hidden',
        // @ts-ignore
        width: '100%',
        // @ts-ignore
        [theme.breakpoints.down('sm')]: {
            padding: '10px 20px 0',
        },
        '@media (any-pointer: fine)': {
            paddingTop: '30px'
        },
    },
    loading: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.5)',
    },
    drawerClose: {
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 10,
        maxWidth: 24,
        marginLeft: 'auto',
        marginTop: 10,
        marginRight: 10,
        cursor: 'pointer',
        color: '#000 !important',
        borderRadius: '50%',
        background: 'white',
        border: '2px solid white',
        // @ts-ignore
        [theme.breakpoints.down('sm')]: {
            top: 7,
            right: 5,
        },
    },
    icon: {
        display: 'block',
        width: 20,
        height: 20,
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.primary.background,
        color: theme.palette.primary.color,
        '.blackfriday &': {
            border: '1px solid #fff',
        },
        // @ts-ignore
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            height: '100%',
        },
    },
}, { name: 'np-drawer' });

interface NewportDrawerProps {
    anchor?: 'right' |  'left';
    open: boolean;
    close: (e: Event) => void;
    title: string;
    children: any[] | any;
    showClose: boolean;
}

export default function NewportDrawer({ anchor = 'right', open, close, title, children, showClose=true }: NewportDrawerProps) {

    const classes = useStyles();

    return (
        <Drawer className={classes.drawer}
                disableEnforceFocus
                classes={{ paper: classes.paper }}
                anchor={anchor}
                open={open}
                onClose={close}
                ModalProps={{ keepMounted: true, disablePortal: false, }}
        >
            <aside className={classes.wrapper}>
                { showClose && <CloseIcon className={classes.drawerClose} onClick={close} width={44}/> }
                { open ? children : null }
            </aside>
        </Drawer>
    );
}
